module.exports = __webpack_public_path__ + "img/system45-details.92dc8e27.png";